import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminSettingsProfilePage from "pages/AdminView/AdminSettingsProfilePage/AdminSettingsProfilePage";
import RecruiterSettingsProfilePage from "pages/RecruitersView/RecruiterSettingsProfilePage/RecruiterSettingsProfilePage";
import ErrorPage from "pages/ErrorPage/ErrorPage";

export default function SettingsProfileSwitch() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminSettingsProfilePage />;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterSettingsProfilePage />;
  } else {
    return <ErrorPage />;
  }
}
